import { publicUrlFor } from "../../globals/constants";

function JobZImage(props) {
    const src = isDirectUrl(props.src) ? props.src : publicUrlFor(props.src);
    return(
        <>
            <img {...props} src={src} alt={props.alt}/>
        </>
    )
}

function isDirectUrl(src = "") {
    return /^(https?:|blob:|data:|\/api\/|\/assets\/)/.test(src);
}

export default JobZImage;
